import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import { Link } from "react-router-dom";
import StockItemsTable from "../../../components/Tables/StockItemsTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class StockItems extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {userPermissions} = this.props;
    const userHasCreatePermission = userPermissions.includes('stock.create');

    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Stok Kalemleri"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Stok Kalemleri", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="STOK KALEMLERİ"
              title="Ürün ve malzeme stoklarını yönetin"
              description="Stok seviyelerini, maliyetleri ve ürün bilgilerini tek merkezden takip edin."
              actionTo={userHasCreatePermission ? "/stock/item-add" : null}
              actionLabel="Yeni stok kalemi"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Stok Kalemleri</h2>
                    {userHasCreatePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/stock/item-add">Yeni Stok Kalemi</Link>
                              </li>
                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <StockItemsTable />
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({
  stockItems: stockReducer.stockItems,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockItems)));
